import React from "react";
import ArrowIcon from "../arrowIcon/arrowIcon";
import Icon from "../icon/icon";
import "./menuItem.scss";

export interface IMenuItemProps {
  ignoreHref?: boolean;
  href?: string;
  src?: string;
  srcClass?: string;
  label?: string;
  icon?: string;
  svg?: () => React.ReactNode;
  labelClass?: string;
  pushMenuStack?: (
    id: string | undefined,
    label: string | undefined,
    icon: string | undefined,
    svg: (() => React.ReactNode) | undefined,
    src: string | undefined,
    href: string | undefined,
    subMenuUseHref: boolean | undefined,
    linkClass: string | undefined,
    extras: unknown | undefined
  ) => void;
  linkClass?: string;
  menuId?: string;
  subMenuUseHref?: boolean;
  extras?: unknown;
}

const MenuItem = (props: IMenuItemProps) => {
  const getHref = () => {
    if (props.ignoreHref) {
      return undefined;
    }

    if (props.href) {
      return props.href;
    }

    return "";
  };

  const renderMenuItem = () => {
    return (
      <>
        {props.src && (
          <img
            src={props.src}
            className={`menu-item-img ${
              props.srcClass ? props.srcClass : null
            }`}
            alt={props.label}
          ></img>
        )}
        {props.icon && (
          <Icon className="align-text-top menu-item-icon">{props.icon}</Icon>
        )}
        {props.svg && (
          <span className="align-text-top menu-item-svg">{props.svg()}</span>
        )}
        <span
          className={`ml-2 menu-item-label align-text-top ${
            props.labelClass ? props.labelClass : ""
          }`}
        >
          {props.label}
        </span>
        {props.pushMenuStack && (
          <Icon className="align-middle menu-item-icon right-arrow-10">
            keyboard_arrow_right
          </Icon>
        )}
      </>
    );
  };

  const onClick = props.pushMenuStack
    ? (event: React.MouseEvent<HTMLElement>) => {
        if (props.pushMenuStack) {
          props.pushMenuStack(
            props.menuId,
            props.label,
            props.icon,
            props.svg,
            props.src,
            props.href,
            props.subMenuUseHref,
            props.linkClass,
            props.extras
          );
          event.preventDefault();
        }
      }
    : (event: React.MouseEvent<HTMLElement>) => {
        if (!getHref()) {
          event.preventDefault();
        }
      };

  const linkClassName = () => {
    return `d-block menu-item-content ${
      props.linkClass ? props.linkClass : ""
    }`;
  };

  const linkOrSpan = () => {
    if (getHref()) {
      return (
        <a className={linkClassName()} href={getHref()} onClick={onClick}>
          {renderMenuItem()}
        </a>
      );
    }

    return <span className={linkClassName()}>{renderMenuItem()}</span>;
  };

  return (
    <div className="row menu-item">
      {props.pushMenuStack ? (
        <div className="col-12">
          <button className="btn-color" onClick={onClick}>
            {linkOrSpan()}
          </button>
        </div>
      ) : (
        <div className="col-12">{linkOrSpan()}</div>
      )}
    </div>
  );
};

export default MenuItem;
